<template>
  <div id="hrms13x-detail-tab4" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab4">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM81X5']['10'] }}
      </h3>
    </div>
    <div id="tab4" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <hrms-table :columns="tab4Table" :data="data" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms13x-detail-tab4',
  props: [ 'labels', 'data', 'tab4Table' ]
}
</script>


// WEBPACK FOOTER //
// detailTab4.vue?2f69e746